<template>
  <div id="app">
    <!-- <router-view /> -->
    <van-overlay :show="isGetXcode">
      <van-loading class="app-loading" size="24px" vertical>加载中...</van-loading>
    </van-overlay>
    <div v-if="!isGetXcode" class="app-context">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
      <van-tabbar
        v-show="isShowTabbar"
        v-model="active"
        class="footer"
        active-color="#0F47C1"
        inactive-color="#9D9D9D"
        style="z-index: 9999;"
      >
        <van-tabbar-item
          v-for="item in tabList"
          :key="item.routes"
          :to="item.routes"
          replace
        >
          <span>{{ item.name }}</span>
          <template #icon="props">
            <svg-icon :icon-class="props.active?item.icons.active:item.icons.default" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import fastClick from 'fastclick';
import { Tabbar, TabbarItem, Overlay, Loading, Toast } from 'vant';
export default {
  name: 'App',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Toast.name]: Toast
  },
  data() {
    return {
      isGetXcode: true,
      active: 0,
      tabList: [
        {
          name: '选课',
          routes: '/course/index',
          icons: {
            default: 'course_nor',
            active: 'course_sel'
          }
        },
        {
          name: '学习',
          routes: '/study/index',
          icons: {
            default: 'study_nor',
            active: 'study_sel'
          }
        },
        {
          name: '课程',
          routes: '/study/course',
          icons: {
            default: 'study_course_nor',
            active: 'study_course_sel'
          }
        },
        {
          name: '我的',
          routes: '/mine',
          icons: {
            default: 'my_nor',
            active: 'my_sel'
          }
        }]
    };
  },
  computed: {
    isShowTabbar() {
      let boolenType;
      if (['CourseIndex', 'StudyIndex', 'StudyCourse', 'Mine'].indexOf(this.$route.name) > -1) {
        boolenType = true;
      } else {
        boolenType = false;
      }
      return boolenType;
    }
  },
  watch: {
    $route(val) {
      let name = val.name;
      console.log(name);
      switch (name) {
        case 'CourseIndex':
          this.active = 0;
          break;
        case 'StudyIndex':
          this.active = 1;
          break;
        case 'StudyCourse':
          this.active = 2;
          break;
        case 'Mine':
          this.active = 3;
          break;
      }
    }
  },
  beforeMount() {
    fastClick.attach(document.body);
    fastClick.prototype.focus = (ele) => {
      'use strict';
      ele.focus();
    }; // 修改focus()方法
  },
  async created() {
    if (window.location.href.indexOf('code=') > -1) {
      this.isGetXcode = true;
      /**
       * 全局方法
       * 根据分校code获取分校id
       */
      await this.urlTogetCampusCode();
      this.isGetXcode = false;
    } else {
      localStorage.removeItem('xsid');
      await this.getCampusList();
      console.log(this.isGetXcode);
    }
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('userMsg') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('userMsg'))));

    /**
     * 在页面刷新时将vuex里的信息保存到localStorage里
     */
    window.addEventListener('pagehide', () => {
      localStorage.setItem('userMsg', JSON.stringify(this.$store.state));
    });

    // 全局禁止输入空格
    // window.onkeypress = (event) => {
    //   if (event.keyCode === 32) event.returnValue = false;
    // };
  },
  methods: {
    // 获取校区列表
    async getCampusList() {
      await this.$store.dispatch('GetCampusList').then(res => {
        if (res.code === 200) {
          let frontCartCampusList = res.data;
          frontCartCampusList.unshift({
            campusId: '',
            campusName: '全部校区',
            campusType: '1',
            id: ''
          });
          console.log(frontCartCampusList);
          if (frontCartCampusList.length > 0) {
            frontCartCampusList[0].isChosed = true;
            localStorage.setItem('frontCartCampusList', JSON.stringify(frontCartCampusList));
            if (frontCartCampusList[0].id) {
              let id = frontCartCampusList[0].id;
              localStorage.setItem('xsid', id);
            }
          }
        }
        this.isGetXcode = false;
      }).catch(() => {
        this.isGetXcode = false;
      });
    }
  }
};
</script>

<style lang="scss">
html,
body {
  -webkit-overflow-scrolling: touch;
}

#app {
  font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #f3f5f6;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */

  .van-tabbar--fixed {
    z-index: 1999 !important;
  }

  .app-loading {
    padding-top: 20vh;
  }
  .van-tabbar-item {
    font-size: 24px;
    font-weight: bold;
    transform: scale(0.83);
  }
}

.logout-dialog {
  z-index: 99999 !important;
}

.app-context {
  width: 100%;
  height: 100%;
}

// body {
//   padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
//   padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
// }
</style>



// WEBPACK FOOTER //
// src/App.vue